import React from 'react'
import styles from './ClubEventCard.scss'
import {MountOnHoverCard} from 'common/hovercards/MountOnHoverCard'
import {CardBody} from 'common/hovercards/CardBody'
import {urls} from 'lib/urls'
import {getTimeSpanStr} from 'lib/eventsUtils'

const CardHeader = ({event}) => (
  <a href={`/events/${event.slug}`} style={{color: '#fff', textDecoration: 'none'}} target='_blank'>{event.name}</a>
)

export class ClubEventCard extends React.PureComponent {
  render () {
    const {children, event, showDateTime, showLocation, showOrganizers, showImage} = this.props

    const content = <div className={styles.content}>
      <div className={styles.left}>
        {showDateTime && getTimeSpanStr(event)}
        {showLocation && event.location && <div className={styles.location}>{event.location}</div>}
        {showOrganizers && event.organizerNames && event.organizerNames.length > 0 &&
          <div className={styles.organzier}>
            Organizer{event.organizerNames.length > 1 && 's'}: {event.organizerNames.join(', ')}
          </div>}
      </div>
      {showImage && <div className={styles.right}>
        <img src={urls.photos.centi(event.highlightedPhotoId)} />
      </div>}
    </div>

    return (
      <MountOnHoverCard wrappedChildren={children}>
        <CardBody
          header={<CardHeader event={event} />}
          content={content} />
      </MountOnHoverCard>
    )
  }
}
